import { InjectionKey, Ref } from "vue";
import { reloadFunction } from "@/functions/utils/CommonUtils";

export const reloadKey: InjectionKey<reloadFunction> = Symbol("reload");
